import React, { Component } from 'react'
import cs from 'classnames'

import isEqual from 'lodash/isEqual'

// ////////////////////////////////////////////////////////////////// COMPONENTS
import SpecialtiesText from '../modules/categories/components/SpecialtiesText'
import TextButton from './buttons/text'
import { ArrowIcons } from './icons'

// /////////////////////////////////////////////////////////////////////////////
// ////////////////////////////////////////////////////////////// EXPORT DEFAULT

type Props = {
  tags: Array<any>
  children?: React.ReactNode
}
type States = {
  collapsable: boolean
  collapsed: boolean
}

class CollapsingTagsList extends Component<Props, States> {
  _container: any
  _inner: any

  constructor(props: Props) {
    super(props)

    this.state = {
      collapsable: false,
      collapsed: true,
    }
  }

  componentDidUpdate(oldProps: any) {
    if (!isEqual(oldProps, this.props)) {
      this.updateCollapseState()
    }
  }

  refContainer = (el: any): any => {
    this._container = el // eslint-disable-line
    this.updateCollapseState()
  }

  refInner = (el: any): any => {
    this._inner = el // eslint-disable-line
    this.updateCollapseState()
  }

  handleCountClick = async (): Promise<any> => {
    this.setState({
      ...this.state,
      collapsed: await this.asyncSetState(!this.state.collapsed),
    })
  }

  updateCollapseState = async (): Promise<any> => {
    const outer = this._container // eslint-disable-line
    const inner = this._inner // eslint-disable-line

    if (outer && inner) {
      const result = inner.offsetHeight > outer.offsetHeight
      this.setState({
        collapsable: await this.asyncSetState(result),
      })
    }
  }

  asyncSetState = (data: any): any => {
    return Promise.resolve(data) // eslint-disable-line
  }

  renderCount(count: any): any {
    return (
      <TextButton
        className="action-link resource-tags__disclosure"
        onClick={this.handleCountClick}
      >
        {count}
        <ArrowIcons position="up" title="Up" width={18} />
      </TextButton>
    )
  }

  render(): React.ReactElement {
    const { tags, children } = this.props
    const { collapsable, collapsed } = this.state
    const classes = cs({
      resource__tags: true,
      'resource-tags': true,
      'resource-tags--collapsable': collapsable,
      'resource-tags--collapsed': collapsed,
    })

    return (
      <div className={classes} ref={this.refContainer}>
        {collapsable && this.renderCount(tags.length)}
        <div className="resource__tag-labels" ref={this.refInner}>
          {children ? children : <SpecialtiesText categories={tags} />}
        </div>
      </div>
    )
  }
}

// /////////////////////////////////////////////////////////////////////////////
// ////////////////////////////////////////////////////////////// EXPORT DEFAULT
export default CollapsingTagsList
